module.exports = __webpack_public_path__ + "static/img/shade.69dbb4bd.svg";